// src/composables/useAuth.js
import { ref, watch } from 'vue'
import api from '@/services/api'
import { useRouter } from 'vue-router'

export function useAuth() {
  const token = ref(sessionStorage.getItem('token') || '')
  const router = useRouter()

  // Cada vez que cambie el token, actualiza sessionStorage y el header
  watch(token, nuevo => {
    if (nuevo) {
      sessionStorage.setItem('token', nuevo)
      api.defaults.headers.common['Authorization'] = `Bearer ${nuevo}`
    } else {
      sessionStorage.removeItem('token')
      delete api.defaults.headers.common['Authorization']
    }
  })

  // Iniciar sesión y almacenar token + permisos
  async function login(email, password) {
    try {
      const { data } = await api.post('/login', { email, password })
      // Desestructura user para no tener 'user' indefinido
      const { token: jwt, user } = data

      // 1. Guarda el token (dispara el watch)
      token.value = jwt

      // 2. Guarda los permisos en sessionStorage
      //    Asegúrate que tu API devuelva user.permissions como array de strings
      sessionStorage.setItem(
        'permissions',
        JSON.stringify(user.permissions)
      )

      // 3. Redirige al dashboard/home
      router.push({ name: 'home' })
    } catch (error) {
      throw error.response?.data?.message || error.message
    }
  }

  // Cerrar sesión: limpia token y permisos
  function logout() {
    token.value = ''                    // limpia token y header
    sessionStorage.removeItem('permissions')
    router.push({ name: 'login' })
  }

  return { token, login, logout }
}